import { render, staticRenderFns } from "./YeastarCloudPbxRecording.vue?vue&type=template&id=74c2ab8e&scoped=true"
import script from "./YeastarCloudPbxRecording.vue?vue&type=script&lang=js"
export * from "./YeastarCloudPbxRecording.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c2ab8e",
  null
  
)

export default component.exports